module.exports = __webpack_public_path__ + "static/img/bigDataGif.9732bf9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigDataGif.gif
// module id = iRMI
// module chunks = 2